import React, { useState } from "react";
import "./ResponsibilityCards.css";

const ResponsibilityCards = ({ cards, language }) => {
  const [selectedCards, setSelectedCards] = useState([]);
  const [draggedCard, setDraggedCard] = useState(null);
  const [textAreaValues, setTextAreaValues] = useState({});

  const handleCardClick = (card) => {
    if (selectedCards.includes(card.key)) {
      setSelectedCards(selectedCards.filter((key) => key !== card.key));
    } else {
      setSelectedCards([...selectedCards, card.key]);
    }
  };

  const handleTextAreaChange = (cardKey, value) => {
    setTextAreaValues((prev) => ({
      ...prev,
      [cardKey]: value,
    }));
  };

  const isTextAreaCard = (cardKey) => {
    return (
      cardKey === "覆写留痕" ||
      cardKey === "Override Trace" ||
      cardKey.includes("[free-text input]") ||
      cardKey.includes("【弹出文本框供填写】")
    );
  };

  const handleDragStart = (e, card) => {
    setDraggedCard(card);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  };

  const handleDrop = (e) => {
    e.preventDefault();
    if (draggedCard) {
      // Here you could implement actual drag-and-drop logic
      // For now, we'll just reset the dragged card
      setDraggedCard(null);
    }
  };

  const getCardType = (cardKey) => {
    const typeMap = {
      "Source Inquiry": "inquiry",
      来源询问: "inquiry",
      "Audit Request": "audit",
      审计要求: "audit",
      "Override Trace": "override",
      覆写留痕: "override",
      "Comms Template": "communication",
      沟通模板: "communication",
      "Process Primacy": "process",
      流程主权: "process",
      "Values Anchor": "values",
      价值锚定: "values",
      "Buffer Policy": "buffer",
      制度缓冲: "buffer",
      "Resource Pairing": "resource",
      资源配套: "resource",
      "Risk Alert": "risk",
      风险预警: "risk",
      Responsibility: "responsibility",
      责任界定: "responsibility",
      "Strategic Challenge": "strategic",
      战略质疑: "strategic",
      "Professional Support": "support",
      专业支持: "support",
    };
    return typeMap[cardKey] || "default";
  };

  const getCardIcon = (cardType) => {
    const iconMap = {
      inquiry: "🔍",
      audit: "📊",
      override: "✏️",
      communication: "💬",
      process: "⚙️",
      values: "🎯",
      buffer: "⏱️",
      resource: "🔧",
      risk: "⚠️",
      responsibility: "👤",
      strategic: "🧠",
      support: "🤝",
      default: "📋",
    };
    return iconMap[cardType] || "📋";
  };

  const getSectionTitle = () => {
    if (language === "zh") {
      return "责任卡片 - 点击选择相关考虑因素";
    }
    return "Responsibility Cards - Click to select relevant considerations";
  };

  const getSelectedCount = () => {
    if (language === "zh") {
      return `已选择 ${selectedCards.length} 张卡片`;
    }
    return `${selectedCards.length} cards selected`;
  };

  return (
    <div className="responsibility-cards">
      <div className="cards-header">
        <h4 className="cards-title">{getSectionTitle()}</h4>
        <div className="selected-count">{getSelectedCount()}</div>
      </div>

      <div
        className="cards-grid"
        onDragOver={handleDragOver}
        onDrop={handleDrop}
      >
        {cards.map((card, index) => {
          const cardType = getCardType(card.key);
          const isSelected = selectedCards.includes(card.key);

          return (
            <div
              key={index}
              className={`responsibility-card ${cardType} ${
                isSelected ? "selected" : ""
              }`}
              onClick={() => handleCardClick(card)}
              draggable
              onDragStart={(e) => handleDragStart(e, card)}
            >
              <div className="card-header">
                <span className="card-icon">{getCardIcon(cardType)}</span>
                <h5 className="card-title">{card.key}</h5>
                {isSelected && <span className="selected-indicator">✓</span>}
              </div>
              <div className="card-content">
                <p className="card-text">{card.text}</p>
                {isTextAreaCard(card.key) && (
                  <div className="card-textarea-container">
                    <textarea
                      className="card-textarea"
                      placeholder={
                        language === "zh"
                          ? "请输入您的理由..."
                          : "Enter your rationale..."
                      }
                      value={textAreaValues[card.key] || ""}
                      onChange={(e) =>
                        handleTextAreaChange(card.key, e.target.value)
                      }
                      rows={3}
                    />
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {selectedCards.length > 0 && (
        <div className="selected-cards-summary">
          <h5>
            {language === "zh"
              ? "您选择的考虑因素："
              : "Your selected considerations:"}
          </h5>
          <div className="selected-list">
            {selectedCards.map((cardKey) => {
              const card = cards.find((c) => c.key === cardKey);
              const hasTextArea = isTextAreaCard(cardKey);
              const textValue = textAreaValues[cardKey];

              return (
                <div key={cardKey} className="selected-item">
                  <span className="selected-item-title">{card.key}</span>
                  {hasTextArea && textValue && (
                    <div className="selected-item-text">
                      <strong>
                        {language === "zh" ? "理由：" : "Rationale:"}
                      </strong>
                      <p>{textValue}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default ResponsibilityCards;
